var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectanglefillonrectanglefill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.398438 12.0537C0.398438 13.9434 1.38281 14.9189 3.29004 14.9189H3.7207V7.25488C3.7207 4.64453 5.1709 3.20312 7.79883 3.20312H19.0664V3.08887C19.0664 1.20801 18.0732 0.223633 16.1748 0.223633H3.29004C1.38281 0.223633 0.398438 1.20801 0.398438 3.08887V12.0537ZM7.9043 19.1113H20.7012C22.5996 19.1113 23.6016 18.127 23.6016 16.2461V7.36035C23.6016 5.47949 22.5996 4.49512 20.7012 4.49512H7.9043C5.99707 4.49512 5.0127 5.4707 5.0127 7.36035V16.2461C5.0127 18.127 5.99707 19.1113 7.9043 19.1113Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectanglefillonrectanglefill);
export default __webpack_public_path__ + "static/media/rectangle.fill.on.rectangle.fill.1627e4dc.svg";
export { ForwardRef as ReactComponent };